<div style="text-align: center; font-weight: bold">{{ label }}</div>
<div class="chart-container">
  <canvas #chart></canvas>
</div>
